export function setFocusOnFirstInput(selector = 'input') {
  const inputs = document.querySelectorAll(selector) as NodeListOf<
    HTMLInputElement
  >;

  if (!inputs.length) return;
  const [firstInputEl] = [...inputs].filter(
    (input: HTMLInputElement) => input.id !== 'searchBar' && !input.value
  );
  if (firstInputEl) firstInputEl.focus();
}
